import { util } from '@/utils/';
import http from '../request/index';

export default {
	///
	//创建营销访问
	createVisit(data) {
		return http.post('/app-api/market/visit/create', data);
	},
	//奖牌分数列表
	getStandardScore() {
		const url = util.urlAddParams('/app-api/market/standard-score/get');
		return http.get(url);
	},
	//题目列表
	listByMarketUser(data) {
		return http.post('/app-api/market/structure/listByMarketUser', data);
	},
	//题目详情
	studyCourse(data) {
		return http.post('/app-api/market/course/studyCourse', data);
	},
	//开始测试
	startTest(data) {
		return http.post('/app-api/market/user-test/startTest', data);
	},
	getWebSocketUrl() {
		const url = util.urlAddParams('/app-api/xfyun/web-iat/getWebsocketUrl');
		return http.get(url);
	},
	//比对分数
	strCompare(data) {
		return http.post('/app-api/str-compare', data);
	},
	//点击下一题回答测试
	answerTest(data) {
		return http.post('/app-api/market/user-test/answerTest', data);
	},
	//拜访签到
	createSign(data) {
		return http.post('/app-api/market/visit-sign/create', data);
	},
	//拜访签到列表
	listSignPage(data) {
		const url = util.urlAddParams('/app-api/market/visit-sign/page', data);
		return http.get(url);
	},
	//删除签到
	delSign(data) {
		const url = util.urlAddParams('/app-api/market/visit-sign/delete', data);
		return http.delete(url);
	},
	//获得所有签到日期
	signDateList(data) {
		const url = util.urlAddParams('/app-api/market/visit-sign/signDateList', data);
		return http.get(url);
	},

	//获得推荐门店分页
	listRecommendPage(data) {
		const url = util.urlAddParams('/app-api/market/recommend-shop/page', data);
		return http.get(url);
	},
	//获得考试列表
	getExamList(data) {
		const url = util.urlAddParams('/app-api/market/exam/list', data);
		return http.get(url);
	},
	//获取营销人员考试列表
	getUserExam(data) {
		const url = util.urlAddParams('/app-api/market/user-exam/getUserExam', data);
		return http.get(url);
	},
	//开始考试
	startUserExam(data) {
		return http.post('/app-api/market/user-exam/startUserExam', data);
	},
	//回答考试
	answerUserExam(data) {
		return http.post('/app-api/market/user-exam/answerUserExam', data);
	},
	//暂停考试
	pauseUserExam(data) {
		return http.post('/app-api/market/user-exam/pauseUserExam', data);
	},
	//申请签约
	applySignUp(data) {
		return http.post('/app-api/market/user/applySignUp', data);
	},
	//获得客户类型
	getDictData(data) {
		const url = util.urlAddParams('/app-api/system/dict-data/list-market', data);
		return http.get(url);
	},
	//获得资料文件夹
	getFolder(data) {
		const url = util.urlAddParams('/app-api/market/db-folder/listByType', data);
		return http.get(url);
	},
	//获得资料
	getMaterial(data) {
		const url = util.urlAddParams('/app-api/market/db-material/pageBy', data);
		return http.get(url);
	}
};
